import React, { FC, memo } from 'react';
import { FilterData } from '@blocs.filter';
import DropdownWithChildren from '@minecraft.dropdown-with-children';
import { SelectOption } from '../../../shared/types';

type Props = { options: SelectOption[] } & FilterData;

const MultipleCheckbox: FC<Props> = ({ name, label, options }) => {
  return <DropdownWithChildren withFormik isMultipleSelect name={name} toggleLabel={label} options={options} />;
};

export default memo(MultipleCheckbox);
